(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const isSearchOpen = this.header.querySelector('details-modal details[open]');
      if (isSearchOpen) return;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.querySelector('details-modal details[open]')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoemantic-comfort-pathway"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('shoemantic-pathway')) {
  customElements.define('shoemantic-pathway', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.finePointer = matchMedia('(hover: hover) and (pointer: fine)');
      this.viewport = this.querySelector('[data-ppi-viewport]');
      this.steps = Array.from(this.querySelectorAll('[data-ppi-step]'));
      this.addEventListener('pointermove', (event) => {
        if (this.reduced.matches || !this.finePointer.matches || this.dataset.activateHover !== 'true') return;
        const card = event.target.closest('.ppi__capsule');
        if (!card || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          const rect = card.getBoundingClientRect();
          card.style.setProperty('--ppi-pointer-x', `${event.clientX - rect.left}px`);
          card.style.setProperty('--ppi-pointer-y', `${event.clientY - rect.top}px`);
          this.frame = null;
        });
      }, {signal, passive:true});
      this.addEventListener('focusin', (event) => {
        const step = event.target.closest('[data-ppi-step]');
        if (step) this.showStep(step);
      }, {signal});
      this.addEventListener('shopify:block:select', (event) => {
        const step = event.target.closest('[data-ppi-step]');
        if (step) { step.classList.add('is-selected'); this.showStep(step); }
      }, {signal});
      this.addEventListener('shopify:block:deselect', (event) => {
        event.target.closest('[data-ppi-step]')?.classList.remove('is-selected');
      }, {signal});
      if (this.dataset.reveal === 'fade_up' && !this.reduced.matches && !window.Shopify?.designMode && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            if (!this.reduced.matches) {
              this.animation = entry.target.animate([{opacity:0,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:500,easing:'ease-out'});
            }
            this.observer.unobserve(entry.target);
          });
        }, {threshold:0.1});
        const header = this.querySelector('.ppi__header');
        if (header) this.observer.observe(header);
      }
    }
    showStep(step) {
      if (!this.viewport || this.viewport.scrollWidth <= this.viewport.clientWidth) return;
      const viewport = this.viewport.getBoundingClientRect();
      const card = step.getBoundingClientRect();
      this.viewport.scrollBy({left:card.left - viewport.left - (viewport.width - card.width) / 2,behavior:this.reduced.matches ? 'auto':'smooth'});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.animation?.cancel();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
